import { useAuth } from "@vega-api/custom";
import { getCurrentPortalType } from "@vega-api/extended/auth/redirectUtils";
import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import {
  CardVariant,
  EmptyCard,
} from "@vega-core/components/Cards/EmptyCard/EmptyCard";
import { m } from "@vega-core/paraglide/messages";

export const TermsAndConditionsEmptyState = () => {
  const { logout } = useAuth();

  return (
    <EmptyCard
      actions={
        <ThemedButton
          dataTestId="terms-empty-logout-button"
          onClick={() =>
            logout({
              isGlobal: true,
              savePath: false,
              source: getCurrentPortalType(),
            })
          }
          variant="primary"
        >
          {m.welcome_terms_emptyLogout()}
        </ThemedButton>
      }
      description={m.welcome_terms_emptyDescription()}
      title={m.welcome_terms_emptyTitle()}
      variant={CardVariant.NoResults}
    />
  );
};
